import { Navigate } from 'react-router-dom'
import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { datadogRum } from '@datadog/browser-rum'

import { useAppDispatch, useAppSelector } from './store/hooks'
import {
  featureFlagsFlagEvaluated,
  selectEmailAddress,
  selectFeatureFlagsEvaluated,
  selectLinkedServices,
  selectRoles,
  selectSessionStatus,
  selectUserID,
  useScribeAccreditationAnalysisChanged,
  useEventsChanged,
  useTranscriptEditorChanged,
  useCreateV4Changed,
} from './v3/settings/settings.slice'
import featureFlagClient, { Event } from './utilities/feature-flag-client'
import useSession from './authentication/hooks/use-session'

const PrivateRoute = ({ element }: any) => {
  let { isAuthenticated, isLoading } = useAuth0()
  let session = useSession()
  let sessionStatus = useAppSelector(selectSessionStatus)
  let dispatch = useAppDispatch()
  let emailAddress = useAppSelector(selectEmailAddress)
  let userID = useAppSelector(selectUserID)
  let roles = useAppSelector(selectRoles)
  let linkedServiceIDs = useAppSelector(selectLinkedServices)
  let flagsEvaluated = useAppSelector(selectFeatureFlagsEvaluated)

  useEffect(() => {
    if (sessionStatus === 'fulfilled') {
      // Register user in DataDog RUM
      datadogRum.setUser({
        id: userID,
        email: emailAddress,
      })

      // Register all Feature Flags in redux store
      let client = featureFlagClient({
        identifier: emailAddress.replace('+', ''),
        attributes: {
          roles,
          linkedServiceIDs,
        },
      })

      client.on(Event.FLAGS_LOADED, () => {
        let useScribeAccreditationAnalysis = client.variation(
          'useScribeAccreditationAnalysis',
          false,
        ) as boolean

        dispatch(
          useScribeAccreditationAnalysisChanged(useScribeAccreditationAnalysis),
        )

        let useEvents = client.variation('useEvents', false) as boolean

        dispatch(useEventsChanged(useEvents))

        let enableTransciptEditor = client.variation(
          'enableTranscriptEditor',
          false,
        ) as boolean

        dispatch(useTranscriptEditorChanged(enableTransciptEditor))

        let useCreateV4 = client.variation('useCreateV4', false) as boolean

        dispatch(useCreateV4Changed(useCreateV4))

        // TODO: We probably should probably handle a failed call to
        // Harness and dispatch this action to set the flags as evaluated
        dispatch(featureFlagsFlagEvaluated())
      })
    }
  }, [sessionStatus, session])

  return isLoading && !flagsEvaluated ? (
    <></>
  ) : isAuthenticated ? (
    flagsEvaluated ? (
      element
    ) : (
      <></>
    ) // Do not render `element` until flags are evaluated, React runs the hooks if this ternary is only one level deep
  ) : (
    <Navigate to="/" replace />
  )
}

export default PrivateRoute
